import {
  BlogPageType,
  blogPageTypes,
  PageTypeEnum,
} from 'common/enums/PageTypeEnum'

export const isBlogPage = (type: PageTypeEnum): type is BlogPageType => {
  return blogPageTypes.includes(type as BlogPageType)
}
